// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setPatientPointsReport,
  setPatientPointsReportLoading
} from 'src/store/modules/reports/patientPoints'

const initialState = {
  patientPointsReport: [],
  patientPointsReportLoading: false
}

export default handleActions(
  {
    [setPatientPointsReport](state, { payload: patientPointsReport }) {
      return {
        ...state,
        patientPointsReport
      }
    },
    [setPatientPointsReportLoading](
      state,
      { payload: patientPointsReportLoading }
    ) {
      return {
        ...state,
        patientPointsReportLoading
      }
    }
  },
  initialState
)
